/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowthinking2Inputs */

const en_aiflowthinking2 = /** @type {(inputs: Aiflowthinking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify is working`)
};

const de_aiflowthinking2 = /** @type {(inputs: Aiflowthinking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify arbeitet`)
};

/**
* | output |
* | --- |
* | "Pulsify is working" |
*
* @param {Aiflowthinking2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowthinking2 = /** @type {((inputs?: Aiflowthinking2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowthinking2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowthinking2(inputs)
	return de_aiflowthinking2(inputs)
});
export { aiflowthinking2 as "aiFlowThinking" }